import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTablet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 20H13.5C13.6333 20 13.75 19.95 13.85 19.85C13.95 19.75 14 19.6333 14 19.5C14 19.3667 13.95 19.25 13.85 19.15C13.75 19.05 13.6333 19 13.5 19H10.5C10.3667 19 10.25 19.05 10.15 19.15C10.05 19.25 10 19.3667 10 19.5C10 19.6333 10.05 19.75 10.15 19.85C10.25 19.95 10.3667 20 10.5 20ZM5 23C4.45 23 3.979 22.8043 3.587 22.413C3.19567 22.021 3 21.55 3 21V3C3 2.45 3.19567 1.979 3.587 1.587C3.979 1.19567 4.45 1 5 1H19C19.55 1 20.021 1.19567 20.413 1.587C20.8043 1.979 21 2.45 21 3V21C21 21.55 20.8043 22.021 20.413 22.413C20.021 22.8043 19.55 23 19 23H5ZM5 16H19V6H5V16ZM5 18V21H19V18H5ZM5 4H19V3H5V4Z",
		fill: "currentColor"
	})
});
export default SvgTablet;
